import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.baseContainerUrl + '/api/v1/'

export const getClusters = (params) => {
  return axios.request({
    url: baseUrl + 'cluster/',
    params: params,
    method: 'get'
  })
}

export const getAllClusters = (params) => {
  return axios.request({
    url: baseUrl + 'all_cluster_list/',
    params: params,
    method: 'get'
  })
}

export const detailCluster = (id, params) => {
  return axios.request({
    url: baseUrl + 'cluster/' + id + '/',
    params: params,
    method: 'get'
  })
}

export const getClusterContainers = (id, params) => {
  return axios.request({
    url: baseUrl + 'cluster/' + id + '/containers/',
    params: params,
    method: 'get'
  })
}

export const deleteCluster = (id, data) => {
  return axios.request({
    url: baseUrl + 'cluster/' + id + '/',
    data: data,
    method: 'delete'
  })
}

export const clusterExcludingContainer = (id, data) => {
  return axios.request({
    url: baseUrl + 'cluster/' + id + '/excluding/',
    data: data,
    method: 'delete'
  })
}

export const clusterRedeployContainer = (id, data) => {
  return axios.request({
    url: baseUrl + 'cluster/' + id + '/redeploy/',
    data: data,
    method: 'post'
  })
}

export const clusterJoinExistedContainer = (id, data) => {
  return axios.request({
    url: baseUrl + 'cluster/' + id + '/join_existed_container/',
    data: data,
    method: 'post'
  })
}
